import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"

const Descuento = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
}: {
  handleSubmit: () => void
  values: { descuento: number }
  setFieldValue: (
    field: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: $TSMigrationFixMe,
    shouldValidate?: boolean
  ) => Promise<void>
  onHide: () => void
}) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='descuento'>
            {t("crear.facturaRec.modal.discountLabel")} (%)
          </label>

          <InputNumber
            autoFocus
            id='descuento'
            name='descuento'
            min={0}
            max={100}
            mode='decimal'
            value={values.descuento}
            onChange={(e) => setFieldValue("descuento", e.value)}
          />
        </div>
      </div>
      <div className='tw-mt-4 tw-flex tw-h-10 tw-flex-row tw-justify-end tw-items-center'>
        <ButtonPrimeReact
          className='tw-mr-3 tw-h-10 tw-flex tw-justify-center  hover:!tw-shadow tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </ButtonPrimeReact>
        <ButtonPrimeReact
          type='submit'
          className='!tw-bg-primary hover:!tw-bg-primary-over hover:!tw-shadow tw-h-10 tw-flex tw-justify-center tw-items-center'
        >
          {t("crear.facturaRec.modal.addButton")}
        </ButtonPrimeReact>
      </div>
    </form>
  )
}

const FormDescuentoDocuemnto = withFormik({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ descuento }: $TSMigrationFixMe) => ({
    descuento: descuento || 0,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSubmit: ({ descuento }, { props }: $TSMigrationFixMe) => {
    props.onChange(descuento)
    props.onHide()
  },
})(Descuento)

export default FormDescuentoDocuemnto
